import { render, staticRenderFns } from "./ServicePostInstructions.vue?vue&type=template&id=09cb6f0e&scoped=true&lang=pug&"
import script from "./ServicePostInstructions.vue?vue&type=script&lang=js&"
export * from "./ServicePostInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ServicePostInstructions.vue?vue&type=style&index=0&id=09cb6f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb6f0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VSpacer,VTextField,VTextarea})
